import React, {useContext, useState} from 'react';
import {observer} from "mobx-react";
import {CollapsibleSection, joinClassNames, SegmentedButton} from "@dts-soldel/dts-react-common";
import MobXContext from "../../../app/mobx/MobXContext";
import UtahIDTypes from "./UtahIDTypes";
import ConfiguratorUtahIdNonCustom from "./ConfiguratorUtahIdNonCustom";
import ConfiguratorUtahIdCustom from "./ConfiguratorUtahIdCustom";
import HelpIcon from "../HelpIcon/HelpIcon";
import HelpText from "../HelpIcon/HelpText";
import Icons from "../../../misc/Icon";

const propTypes = {};
const defaultProps = {};

const ConfiguratorUtahId = () => {
	const {configuratorStore} = useContext(MobXContext);
	const [isExpanded, setIsExpanded] = useState(false);

	return (
		<CollapsibleSection
			clickSection={() => setIsExpanded(!isExpanded)}
			expanded={isExpanded}
			title={`Utah ID${configuratorStore.utahIdType === UtahIDTypes.none ? '' : ` - ${configuratorStore.utahIdType}`}`}
			collapsibleIndicator={Icons.iconArrowRight()}
			className={joinClassNames(configuratorStore.utahIdType !== 'none' ? 'configured' : undefined, 'mb1')}
		>
			<SegmentedButton
				className="segmented-button full-width"
				value={configuratorStore.utahIdType}
				label="Utah ID Type"
				options={[
					{value: UtahIDTypes.none, label: 'None'},
					{value: UtahIDTypes.on, label: 'On'},
					{value: UtahIDTypes.plain, label: 'Plain'},
					{value: UtahIDTypes.custom, label: 'Custom'},
				]}
				field="utahIdType"
				onChange={configuratorStore.setFieldValue}
				showLabel={false}
				children={
					<HelpIcon
						popOverText={HelpText.customIdType}
						onUseExampleField="utahIdType"
						onUseExampleFieldValue={configuratorStore.setFieldValue}
					/>
				}
			/>
			{configuratorStore.utahIdType === UtahIDTypes.plain ? <ConfiguratorUtahIdNonCustom/> : undefined}
			{configuratorStore.utahIdType === UtahIDTypes.on ? <div>This is the "Zero Config" option. The header is automatically configured to show a Sign In button or the logged in Utah ID user's name, but your application will receive no notifications when a user is signed in or out.</div> : undefined}
			{configuratorStore.utahIdType === UtahIDTypes.custom ? <ConfiguratorUtahIdCustom/> : undefined}
		</CollapsibleSection>
	);
};

ConfiguratorUtahId.propTypes = propTypes;
ConfiguratorUtahId.defaultProps = defaultProps;

export default observer(ConfiguratorUtahId);
